import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Modal } from "react-bootstrap";
import "./Modal.css";
import "./GuideSettingsDialog.css";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { slice1Actions } from "../../store/reducer";

const GuideSettingsDialog = (props) => {
  const dispatch = useDispatch();
  let _GuideSettings = useSelector((state) => state.GuideSettings);
  let MobileMode = useSelector((state) => state.MobileMode);
  const [GuideSettings, setGuideSettings] = useState(_GuideSettings);
  // "All places" tile photo picker: the guide's place photos (2026-10-18).
  const [allPhotoPicker, setAllPhotoPicker] = useState(false);
  const guideCover = window.guide_obj?.attributes?.image_m || window.guide_obj?.attributes?.image || "";
  const placePhotos = allPhotoPicker
    ? [...new Set((window.guide_obj?.places?.placesList || []).filter((p) => !p.Hidden).map((p) => p.Photo_m || p.Photo || "").filter(Boolean))].slice(0, 300)
    : [];

  const saveSettings = () => {
    dispatch(slice1Actions.setGuideSettings({ value: GuideSettings }));
    props.onHide();
  };

  //console.log("this.state.edit_mode", this.state.edit_mode);
  // if (this.state.AlertModalShow)
  //   return (
  //     <AlertModal
  //       show={this.state.AlertModalShow}
  //       onHide={() => this.setState({ AlertModalShow: false })}
  //       AlertModalTitle={this.state.AlertModalTitle}
  //       AlertModalMessage={this.state.AlertModalMessage}
  //       AlertModalButtons={this.state.AlertModalButtons}
  //     />
  //   );
  let GuideSettings_copy = JSON.parse(JSON.stringify(GuideSettings));

  const HourPicker = ({ label, value, onChange, filterFn }) => {
    const hours = Array.from({ length: 24 }, (_, i) => i).filter(filterFn ?? (() => true));
    return (
      <div className="gsd-hour-row">
        <span className="gsd-toggle-label">{label}</span>
        <select
          className="gsd-hour-select"
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value))}
        >
          {hours.map((h) => <option key={h} value={h}>{h}:00</option>)}
        </select>
      </div>
    );
  };

  const ToggleRow = ({ label, checked, onToggle }) => (
    <div className="gsd-toggle-row">
      <span className="gsd-toggle-label">{label}</span>
      <span className={`gsd-toggle${checked ? " on" : ""}`} onClick={onToggle} />
    </div>
  );

  return (
    <div className="modal">
      <Modal
        {...props}
        dialogClassName="gsd-dialog"
        aria-labelledby="gsd-title"
        centered={false}
        scrollable={false}
        fade={false}
      >
        <Modal.Body style={{ padding: 0 }}>
          <div className="gsd-shell">

            {/* ── Header ── */}
            <div className="gsd-header">
              <div className="gsd-header-icon">
                <FontAwesomeIcon icon={solid("sliders")} />
              </div>
              <h2 className="gsd-title" id="gsd-title">Guide Settings</h2>
              <button className="gsd-save-btn" onClick={saveSettings}>
                <FontAwesomeIcon icon={solid("check")} />
                Save
              </button>
              <button className="gsd-close" onClick={props.onHide}>
                <FontAwesomeIcon icon={solid("xmark")} />
              </button>
            </div>

            {/* ── Body ── */}
            <div className="gsd-body">

              {/* General */}
              <div className="gsd-section">
                <ToggleRow
                  label="Hide Schedule pane"
                  checked={GuideSettings.hide_schedule}
                  onToggle={() => {
                    GuideSettings_copy.hide_schedule = !GuideSettings_copy.hide_schedule;
                    setGuideSettings(GuideSettings_copy);
                  }}
                />
              </div>

              {/* Schedule */}
              <div className="gsd-section">
                <div className="gsd-section-label">Schedule</div>
                <HourPicker
                  label="Day start"
                  value={GuideSettings.schedule_day_start ?? 9}
                  onChange={(h) => {
                    GuideSettings_copy.schedule_day_start = h;
                    if ((GuideSettings_copy.schedule_day_end ?? 20) <= h) GuideSettings_copy.schedule_day_end = h + 1;
                    setGuideSettings(GuideSettings_copy);
                  }}
                />
                <HourPicker
                  label="Day end"
                  value={GuideSettings.schedule_day_end ?? 20}
                  filterFn={(h) => h > (GuideSettings.schedule_day_start ?? 9)}
                  onChange={(h) => { GuideSettings_copy.schedule_day_end = h; setGuideSettings(GuideSettings_copy); }}
                />
                <ToggleRow
                  label="Schedules are separate plans — a place used in one can still be suggested for the others (turn off when the schedules are parts of one trip)"
                  checked={GuideSettings.schedules_share_places !== true}
                  onToggle={() => {
                    GuideSettings_copy.schedules_share_places = GuideSettings_copy.schedules_share_places !== true;
                    setGuideSettings(GuideSettings_copy);
                  }}
                />
              </div>

              {/* Guide Mode */}
              <div className="gsd-section">
                <div className="gsd-section-label">Guide Mode</div>
                <div className="gsd-mode-group">
                  <button
                    className={`gsd-mode-btn${GuideSettings.mode === "edit" ? " active" : ""}`}
                    onClick={() => {
                      GuideSettings_copy.mode = "edit";
                      GuideSettings_copy.itinerary = { ...(GuideSettings_copy.itinerary ?? {}), directions: false, info: false, photo: true, place_menu: false };
                      setGuideSettings(GuideSettings_copy);
                    }}
                  >Mosaic</button>
                  <button
                    className={`gsd-mode-btn${GuideSettings.mode === "custom_view" ? " active" : ""}`}
                    onClick={() => {
                      GuideSettings_copy.mode = "custom_view";
                      GuideSettings_copy.itinerary = { ...(GuideSettings_copy.itinerary ?? {}), directions: true, info: true, photo: true, place_menu: true };
                      setGuideSettings(GuideSettings_copy);
                    }}
                  >Custom</button>
                </div>
              </div>

              {/* Mosaic */}
              <div className="gsd-section">
                <div className="gsd-section-label">Mosaic</div>
                <ToggleRow
                  label="Mosaic Schedules"
                  checked={GuideSettings.mosaic_schedules !== false}
                  onToggle={() => {
                    GuideSettings_copy.mosaic_schedules = GuideSettings_copy.mosaic_schedules === false ? true : false;
                    setGuideSettings(GuideSettings_copy);
                  }}
                />
                <ToggleRow
                  label="Mosaic Groups"
                  checked={GuideSettings.mosaic_groups !== false}
                  onToggle={() => {
                    GuideSettings_copy.mosaic_groups = GuideSettings_copy.mosaic_groups === false ? true : false;
                    setGuideSettings(GuideSettings_copy);
                  }}
                />
                {/* One tile with every place — shown when it adds something
                    (2+ tiles, none already holding every place). 2026-10-18. */}
                <ToggleRow
                  label="“All places” tile"
                  checked={GuideSettings.mosaic_all !== false}
                  onToggle={() => {
                    GuideSettings_copy.mosaic_all = GuideSettings_copy.mosaic_all === false ? true : false;
                    setGuideSettings(GuideSettings_copy);
                  }}
                />
                {GuideSettings.mosaic_all !== false ? (
                  <div className="gsd-toggle-row">
                    <span className="gsd-toggle-label">Its name</span>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      style={{ maxWidth: 200 }}
                      value={GuideSettings.mosaic_all_label ?? ""}
                      placeholder="All places"
                      onChange={(e) => {
                        GuideSettings_copy.mosaic_all_label = e.target.value;
                        setGuideSettings(GuideSettings_copy);
                      }}
                    />
                  </div>
                ) : null}
                {GuideSettings.mosaic_all !== false ? (
                  <div className="gsd-toggle-row">
                    <span className="gsd-toggle-label">Its photo</span>
                    <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      {GuideSettings.mosaic_all_image || guideCover ? (
                        <img src={GuideSettings.mosaic_all_image || guideCover} alt="" referrerPolicy="no-referrer" style={{ width: 40, height: 50, objectFit: "cover", borderRadius: 6 }} />
                      ) : null}
                      <span style={{ fontSize: 13, color: "#71717A" }}>{GuideSettings.mosaic_all_image ? "" : "Guide cover"}</span>
                      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setAllPhotoPicker(true)}>Change</button>
                    </span>
                  </div>
                ) : null}
                {allPhotoPicker ? (
                  <div
                    onClick={() => setAllPhotoPicker(false)}
                    style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center" }}
                  >
                    <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", borderRadius: 12, padding: 16, width: "min(92vw, 560px)", maxHeight: "80vh", overflowY: "auto" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                        <strong>Photo for the “All places” tile</strong>
                        <button type="button" className="btn btn-sm btn-link" onClick={() => setAllPhotoPicker(false)}>Close</button>
                      </div>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        style={{ marginBottom: 10 }}
                        onClick={() => { delete GuideSettings_copy.mosaic_all_image; setGuideSettings(GuideSettings_copy); setAllPhotoPicker(false); }}
                      >
                        Use the guide's cover photo
                      </button>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(90px, 1fr))", gap: 6 }}>
                        {placePhotos.map((url) => (
                          <img
                            key={url}
                            src={url}
                            alt=""
                            referrerPolicy="no-referrer"
                            loading="lazy"
                            onClick={() => { GuideSettings_copy.mosaic_all_image = url; setGuideSettings(GuideSettings_copy); setAllPhotoPicker(false); }}
                            style={{ width: "100%", aspectRatio: "4/5", objectFit: "cover", borderRadius: 6, cursor: "pointer", outline: url === GuideSettings.mosaic_all_image ? "3px solid #2F6FE5" : "none" }}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>

              {/* Itinerary Content */}
              <div className="gsd-section">
                <div className="gsd-section-label">Itinerary Content</div>
                <ToggleRow
                  label="Weather link"
                  checked={GuideSettings.itinerary?.weather === true}
                  onToggle={() => {
                    GuideSettings_copy.itinerary = {
                      ...(GuideSettings_copy.itinerary ?? {}),
                      weather: !(GuideSettings_copy.itinerary?.weather === true),
                    };
                    setGuideSettings(GuideSettings_copy);
                  }}
                />
                <ToggleRow
                  label="Climate link"
                  checked={GuideSettings.itinerary?.climate === true}
                  onToggle={() => {
                    GuideSettings_copy.itinerary = {
                      ...(GuideSettings_copy.itinerary ?? {}),
                      climate: !(GuideSettings_copy.itinerary?.climate === true),
                    };
                    setGuideSettings(GuideSettings_copy);
                  }}
                />
              </div>

              {/* Interaction Behavior (labeled "Click Behavior" until
                  2026-10-05, renamed for clarity — underlying field is still
                  click_behavior) — decoupled from Guide Mode 2026-10-05.
                  Guide Mode above is ONLY the home-page rendering format now;
                  this controls whether clicking/hovering a place/guide card,
                  map marker, schedule name, or day section runs the
                  toggle-driven behaviors configured below ("Custom") or
                  always opens the full action menu ("Default"), independent
                  of which home-page format is selected. */}
              <div className="gsd-section">
                <div className="gsd-section-label">Interaction Behavior</div>
                <div className="gsd-mode-group">
                  <button
                    className={`gsd-mode-btn${GuideSettings.click_behavior !== "custom" ? " active" : ""}`}
                    onClick={() => {
                      GuideSettings_copy.click_behavior = "default";
                      setGuideSettings(GuideSettings_copy);
                    }}
                  >Default</button>
                  <button
                    className={`gsd-mode-btn${GuideSettings.click_behavior === "custom" ? " active" : ""}`}
                    onClick={() => {
                      GuideSettings_copy.click_behavior = "custom";
                      setGuideSettings(GuideSettings_copy);
                    }}
                  >Custom</button>
                </div>
              </div>

              {/* These sections configure interaction behavior (menus, notes,
                  map click/hover, filtering) — independent of Guide Mode,
                  which only controls whether the home page renders as a
                  Mosaic grid or Custom document. As of 2026-10-05 these
                  toggles only take effect at runtime when Interaction
                  Behavior above is "Custom" (see click_behavior in
                  PlaceCard.js/Map.js/etc., including the hover handler as of
                  today), so the sections themselves are hidden when
                  Interaction Behavior is "Default" — they'd otherwise show
                  controls that silently do nothing. */}
              {GuideSettings.click_behavior === "custom" && (
                <>
                  {/* Places in List */}
                  <div className="gsd-section">
                    <div className="gsd-section-label">Places in List Click</div>
                    <div className="gsd-grid">
                      {[
                        { key: "menu", label: "Display Menu" },
                        { key: "info", label: "Display Notes" },
                        { key: "url", label: "Display URL" },
                        { key: "attributes", label: "Display Details" },
                        { key: "center", label: "Show on map" },
                        { key: "filter", label: "Filter places" },
                        { key: "path_link", label: "Place link" },
                      ].map(({ key, label }) => (
                        <ToggleRow
                          key={key}
                          label={label}
                          checked={GuideSettings.places_list[key]}
                          onToggle={() => {
                            GuideSettings_copy.places_list[key] = !GuideSettings_copy.places_list[key];
                            setGuideSettings(GuideSettings_copy);
                          }}
                        />
                      ))}
                    </div>
                  </div>

                  {/* Places in Map Click */}
                  <div className="gsd-section">
                    <div className="gsd-section-label">Places in Map Click</div>
                    <div className="gsd-grid">
                      {[
                        { key: "menu", label: "Display Menu" },
                        { key: "info", label: "Display Notes" },
                        { key: "url", label: "Display URL" },
                        { key: "attributes", label: "Display Details" },
                        { key: "center", label: "Show on map" },
                        { key: "filter", label: "Filter places" },
                        { key: "path_link", label: "Place link" },
                      ].map(({ key, label }) => (
                        <ToggleRow
                          key={key}
                          label={label}
                          checked={GuideSettings.places_map[key]}
                          onToggle={() => {
                            GuideSettings_copy.places_map[key] = !GuideSettings_copy.places_map[key];
                            setGuideSettings(GuideSettings_copy);
                          }}
                        />
                      ))}
                    </div>
                  </div>

                  {/* Schedule */}
                  <div className="gsd-section">
                    <div className="gsd-section-label">Schedule Click</div>
                    <div className="gsd-grid">
                      {[
                        { key: "menu", label: "Display Menu" },
                        { key: "itinerary", label: "Display Itinerary" },
                        { key: "center", label: "Show on map" },
                        { key: "filter", label: "Filter places" },
                      ].map(({ key, label }) => (
                        <ToggleRow
                          key={key}
                          label={label}
                          checked={GuideSettings.schedule[key]}
                          onToggle={() => {
                            GuideSettings_copy.schedule[key] = !GuideSettings_copy.schedule[key];
                            setGuideSettings(GuideSettings_copy);
                          }}
                        />
                      ))}
                    </div>
                  </div>

                  {/* Day */}
                  <div className="gsd-section">
                    <div className="gsd-section-label">Day Click</div>
                    <div className="gsd-grid">
                      {[
                        { key: "menu", label: "Display Menu" },
                        { key: "center", label: "Show on map" },
                        { key: "filter", label: "Filter places" },
                      ].map(({ key, label }) => (
                        <ToggleRow
                          key={key}
                          label={label}
                          checked={GuideSettings.day[key]}
                          onToggle={() => {
                            GuideSettings_copy.day[key] = !GuideSettings_copy.day[key];
                            setGuideSettings(GuideSettings_copy);
                          }}
                        />
                      ))}
                    </div>
                  </div>

                  {/* Places in Map Hover — desktop only, mouse hover has no
                      touch equivalent, so hidden in mobile mode too. Added
                      2026-10-05. */}
                  {!MobileMode && (
                  <div className="gsd-section">
                    <div className="gsd-section-label">Places in Map Hover</div>
                    <div className="gsd-grid">
                      {[
                        { key: "place", label: "Highlight Place" },
                        { key: "info", label: "Display Details" },
                        { key: "event", label: "Highlight event" },
                      ].map(({ key, label }) => (
                        <ToggleRow
                          key={key}
                          label={label}
                          checked={GuideSettings.places_map_hover[key]}
                          onToggle={() => {
                            GuideSettings_copy.places_map_hover[key] = !GuideSettings_copy.places_map_hover[key];
                            setGuideSettings(GuideSettings_copy);
                          }}
                      />
                    ))}
                    </div>
                  </div>
                  )}
                </>
              )}

            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default GuideSettingsDialog;
